import moment from 'moment-timezone';

export const normalizeTimezone = value => {
    const zone = typeof value === 'string' ? value.trim() : '';
    return moment.tz.zone(zone) ? zone : 'America/New_York';
};

export const zonedMoment = (zone, ...parts) => {
    if (parts.length > 1) {
        // Use setters to preserve native Date's month overflow behaviour.
        return moment.tz([Number(parts[0]), 0, 1], zone)
            .month(Number(parts[1])).date(Number(parts[2]));
    }
    return moment.tz(parts.length ? parts[0] : Date.now(), zone);
};

export const orderMillis = order => Number(order.added_on || order.order_time || order.order_id);

export const calendarRange = (start, end, zone) => {
    const from = moment.tz(start, 'YYYY-MM-DD', true, zone);
    const to = moment.tz(end, 'YYYY-MM-DD', true, zone);
    if (!from.isValid() || !to.isValid() || from.isAfter(to)) {
        throw new Error('Please select a valid date range');
    }
    return { start: from.valueOf(), end: to.add(1, 'day').valueOf() };
};
